import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { valetModel } from '../../../api';
import './ValetV1.scss';
import { ValetInfoV1 } from './ValetInfoV1';
import {
  sendValetApiEvents,
  VALET_EVENTS,
} from '../../../helpers/analytics/valet.analytics';

export default class ValetV1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valet: null,
    };
    this.timer = null;
  }

  componentDidMount() {
    this.getValetInfo();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  startPolling = (time) => {
    const { orderId, userId } = this.props;
    const pollingTime = time || 60;
    if (this.timer) {
      this.stopPolling();
    }
    this.timer = setTimeout(() => {
      sendValetApiEvents(
        VALET_EVENTS.VALET_POLLING_START_EVENT,
        orderId,
        userId,
      );
      this.getValetInfo(true);
    }, pollingTime * 1000);
  };

  stopPolling = () => {
    const { orderId, userId } = this.props;
    sendValetApiEvents(VALET_EVENTS.VALET_POLLING_STOP_EVENT, orderId, userId);
    clearTimeout(this.timer);
  };

  getValetInfo = (isPolling = false) => {
    const { orderId, userId } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    if (isPolling) {
      queryStrings['is_polling'] = isPolling;
    }
    valetModel
      .getValetData(queryStrings)
      .then((response) => {
        if (!response || (response && response.isError === true)) return null;
        sendValetApiEvents(
          VALET_EVENTS.GET_VALET_DETAILS_SUCCESS,
          orderId,
          userId,
        );
        this.setState({
          valet: { ...response },
        });
        if (response?.polling_enabled) {
          this.startPolling(response?.polling_time);
        } else {
          this.stopPolling();
        }
      })
      .catch(() => {
        sendValetApiEvents(
          VALET_EVENTS.GET_VALET_DETAILS_FAILURE,
          orderId,
          userId,
        );
      });
  };

  render() {
    const { valet } = this.state;
    return (
      <div className='valetContainerV1 tw-w-full tw-h-full'>
        {!valet ? (
          <Shimmer height='100%' width='100%' />
        ) : (
          <ValetComponent {...this.props} valet={valet} />
        )}
      </div>
    );
  }
}

function ValetComponent(props) {
  const {
    valet,
    isShowCalls = true,
    orderId,
    userId,
    isWFH,
    orderBasicInfo,
    getOrderBasicInfo,
  } = props;
  const valetTitle = 'Service Professional';
  const valetName = valet?.name;
  const valetId = valet?.driver_fe_id;
  let comp = null;

  if (valetName != undefined) {
    comp = (
      <ValetInfoV1
        valetTitle={valetTitle}
        valet={valet}
        userId={userId}
        valetId={valetId}
        orderId={orderId}
        isWFH={isWFH}
        orderBasicInfo={orderBasicInfo}
        getOrderBasicInfo={getOrderBasicInfo}
      />
    );
  } else if (!isShowCalls) {
    comp = (
      <ValetInfoV1
        valetTitle={valetTitle}
        userId={userId}
        noData={true}
        valetId={valetId}
        orderId={orderId}
        orderBasicInfo={orderBasicInfo}
        getOrderBasicInfo={getOrderBasicInfo}
      />
    );
  }

  return (
    <>
      <div className='valetInfo tw-h-full tw-w-full'>{comp}</div>
    </>
  );
}
